import React, { FC } from 'react';
import { format } from 'date-fns';
import { TAppointment } from '@api/appointments/types';

export const dateFormatter: FC<TAppointment> = (appointment) => {
  const date = format(new Date(appointment.date), 'MM/dd/yyyy');

  return <ul>{String(date)}</ul>;
};
